import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import API from "../api/axios";
import "../styles/auth.css";

const styles = `
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .vs-auth-sub {
    font-size: 13px;
    color: var(--text-3);
    text-align: center;
    margin-bottom: 4px;
  }
  .vs-auth-email-highlight {
    font-size: 14px;
    color: var(--accent);
    text-align: center;
    font-weight: 600;
    margin-bottom: 34px;
    word-break: break-all;
  }
  .vs-auth-hint-small {
    text-align: center;
    font-size: 12px;
    color: var(--text-3);
  }
`;

function VerifyOTP() {
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const email = location.state?.email;

  useEffect(() => {
    const el = document.createElement("style");
    el.textContent = styles;
    document.head.appendChild(el);
    return () => document.head.removeChild(el);
  }, []);

  if (!email) { navigate("/register"); return null; }

  const handleVerify = async () => {
    if (!otp) { toast.error("Please enter the OTP"); return; }
    try {
      setLoading(true);
      await API.post("/auth/verify-otp", { email, otp });
      toast.success("Email verified! You can now login.");
      navigate("/");
    } catch (err) {
      toast.error(err.response?.data?.message || "Verification failed");
    } finally { setLoading(false); }
  };

  const handleResend = async () => {
    try {
      setResendLoading(true);
      await API.post("/auth/resend-otp", { email });
      toast.success("New OTP sent to your email");
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to resend OTP");
    } finally { setResendLoading(false); }
  };

  return (
    <div className="vs-auth-page">
      <div className="vs-auth-card">
        <h1 className="vs-auth-logo">{t("verifyEmail")}</h1>
        <p className="vs-auth-sub">OTP sent to</p>
        <p className="vs-auth-email-highlight">{email}</p>

        <div className="vs-auth-divider">
          <div className="vs-auth-divider-line" />
          <div className="vs-auth-divider-dot" />
          <div className="vs-auth-divider-line" />
        </div>

        <input
          className="vs-auth-otp-input"
          type="text"
          placeholder="······"
          value={otp}
          onChange={e => setOtp(e.target.value)}
          maxLength={6}
          onKeyPress={e => e.key === "Enter" && handleVerify()}
        />

        <button className="vs-auth-btn" onClick={handleVerify} disabled={loading}>
          {loading ? "Verifying…" : t("verifyButton")}
        </button>

        <button className="vs-auth-btn-ghost" onClick={handleResend} disabled={resendLoading}>
          {resendLoading ? "Sending…" : t("resendOtp")}
        </button>

        <p className="vs-auth-hint-small">{t("otpExpiry")}</p>
      </div>
    </div>
  );
}

export default VerifyOTP;